import { Like } from '../types/likes'

export const userHasLiked = (likes: Like[], userId: string) => {
  return likes?.some((like) => like.userWhoLikedId === userId)
}
